import { render, staticRenderFns } from "./bid_form.vue?vue&type=template&id=070389a6&"
import script from "./bid_form.vue?vue&type=script&lang=js&"
export * from "./bid_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports